import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import './Comment.css';

const Comment = (props) => {

    const { number, id, insertDate, author, mobileNumber, itemType, person } = props;
    const { place , comment, changeStatus, status, deleteComment } = props;
    const [showInfo, setShowInfo] = useState(false);

    return ( 
        <div className="comment-layer">
            <span className="comment-number my-2 my-md-0">
                <span>{number}</span>
            </span>
            <div className="d-none d-sm-inline-block">
                <div>
                    <span className="font-weight-bold">
                        {itemType === 'person' ? 'شخص' : 'مکان'} 
                    </span>
                    <small className="mx-1">
                        ( {itemType === 'person' ? person.fullName: place.title}  )
                    </small>
                </div>
                <div>
                    <small className="">
                        {itemType === 'person' ? 'حرفه' : 'دسته بندی'} 
                    </small>
                    <small className="mx-1">:</small>
                    <small className="mx-1">
                        {itemType === 'person' ? person.vocation: place.placeCategoryName}
                    </small>
                </div>
                <div>
                    <small className="">
                        {itemType === 'person' ? 'کد' : 'منطقه'} 
                    </small>
                    <small className="mx-1">:</small>
                    <small className="mx-1">
                        {itemType === 'person' ? person.code: place.areaName}
                    </small>
                </div>
            </div>
            <div className="d-flex flex-column flex-wrap">
                <span className="d-sm-none">
                    <span className="font-weight-bold"> 
                        {itemType === 'person' ? 'شخص' : 'مکان'} 
                    </span>
                    <small className="mx-1">
                        ( {itemType === 'person' ? person.fullName: place.title}  )
                    </small>
                </span>
                <small >{insertDate.split(' ')[0]}</small>
                <small className=" align-items-center"style={{direction:'ltr'}}>{insertDate.split(' ')[1]}</small>
            </div>
            <div className="d-flex flex-column justify-content-center align-items-center">
                {
                    status === 'queue' && 
                    <button className="btn btn-success rounded-pill mb-1" 
                        onClick={() => changeStatus(id)}
                    >انتشار</button>
                }
                <button className="btn btn-danger rounded-pill mb-1"
                    onClick={deleteComment}
                >حذف</button>
                <button className="btn btn-primary rounded-pill"
                    onClick={() => setShowInfo(!showInfo)}
                >
                    {showInfo ? 'بستن' : 'مشاهده'}
                </button>
            </div>
            <div className="col-12">
                <Collapse
                    in={showInfo}
                >
                    <div style={{marginLeft:'-10px', marginRight:'-10px'}}>
                        <div className="mt-2">
                            <small className="font-weight-bold">نام و نام خانوادگی</small>
                            <small className="mx-1 font-weight-bold">:</small>
                            <small className="">{author}</small>
                        </div>
                        <div>
                            <small className="font-weight-bold">شماره موبایل</small>
                            <small className="mx-1 font-weight-bold">:</small>
                            <small className="">{mobileNumber}</small>
                        </div>
                        <div>
                            <small className="font-weight-bold">نظر کاربر : </small>
                            <p className="">
                                <small>{comment}</small>
                            </p>
                        </div>
                    </div>
                </Collapse>
            </div>
        </div>
    );
}
 
export default Comment;